export default __webpack_public_path__ + "static/media/circle.134eeeb1.svg";